'use strict'
require('core-js/modules/es.date.to-string')
exports.__esModule = true
exports.getLastDateInMonth = getLastDateInMonth
exports.daysBetween = daysBetween
exports.move = move
exports.default = void 0

var _consts = require('./consts')
var _getters = require('./getters')
var _setters = require('./setters')

/**
 * getLastDateInMonth
 * Возвращает последнее число месяца в переданной дате
 *
 * @param {Date} date
 * @example
 * getLastDateInMonth( date ) // 31
 * getLastDateInMonth( date2 ) // 28
 * @returns {number}
 * @memberof Time
 */
function getLastDateInMonth(date) {
  var d = new Date(date)
  ;(0, _setters.set)(d, 'd', 1)
  ;(0, _setters.set)(d, 'M', (0, _getters.get)(d, 'M') + 1)
  ;(0, _setters.set)(d, 'd', 0)
  return (0, _getters.get)(d, 'd')
}

/**
 * daysBetween
 * Возвращает количество дней между двумя датами
 *
 * @param {Date} date1
 * @param {Date} date2
 * @returns {number}
 * @memberof Time
 */
function daysBetween(date1, date2) {
  var differenceMs = Math.abs(date1.getTime() - date2.getTime())

  return Math.round(differenceMs / _consts.ONE_DAY_MS)
}

/**
 * move
 * Сдвигает указанную часть времени
 *
 * @param {Date} d
 * @param {PartNameType} partName
 * @param {number} num
 * @memberof Time
 *
 * @example
 * const d = new Date() // 2019 05 15
 * move( d, 'd', 11 ) // d === 2019 05 26
 * move( d, 'y', -2 ) // d === 2017 05 26
 */
function move(d, partName, num) {
  var n = num
  var name = partName
  if (name === 'w') {
    name = 'd'
    n *= 7
  }

  if (name === 'q') {
    name = 'M'
    n *= 3
  }

  var currMonth = (0, _getters.get)(d, 'M')
  var neededMonth = currMonth + n

  ;(0, _setters.set)(d, name, (0, _getters.get)(d, name) + n)
  if (name !== 'M') return
  if (n < 0 && neededMonth < 0) {
    // TODO: сдвиг 31 января на 2 месяца назад не сработает! надо чинить
    return
  }
  if (neededMonth < (0, _getters.get)(d, 'M')) {
    ;(0, _setters.set)(d, 'M', neededMonth)
    ;(0, _setters.set)(d, 'd', getLastDateInMonth(d))
  }
}

var utils = {
  getLastDateInMonth: getLastDateInMonth,
  daysBetween: daysBetween,
  move: move
}
var _default = utils
exports.default = _default



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/utils.js
// module id = 165
// module chunks = 0